export default "assets/images/old-logo-light-503e0756.svg";